import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
  flex: 1;
  padding: 2rem 2rem 1rem;
  // margin-right: -0.2rem;
  background: #f1f4f8;
  height: 100%;
  overflow: auto;
`;
